import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {containerStyles, normalizeStyles, typographyStyles,} from '@webs/components-library/theming';
import {GridColumn} from "@webs/components-library/grid-column";

@customElement('webs-stats-item')
export class StatsItem extends GridColumn {
  static styles = [ ...GridColumn.styles,
    normalizeStyles,
    containerStyles,
    typographyStyles,
    css`
      .card-item {
        text-align: left;
      }
      .card-item p {
        margin: 0;
        padding-top: 0.4rem;
      }

      .card-item--white h3,
      .card-item--white p {
        color: var(--color-white);
      }

      @media only screen and (min-width: 768px){
        .card-item {
          align-items: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
      }
    `,
  ];

  @property()
  title: string;

  @property()
  text: string;

  @property({attribute: 'light', type: Boolean})
  isWhite: boolean;

  protected render(): unknown {
    return html`
        <div class="card-item ${this.isWhite ? 'card-item--white' : ''}">
          <h3 class="h1 no-margin">${this.title}</h3>
          ${this.text ? html`<p>${this.text}</p>` : ''}
        </div>`;
  }
}
